<template>
  <div>
    <Modal :key="modalKey" v-model="addSupplierModal" class-name="addSupplierStyle" width="1000" :footer-hide="supplierType === 'look'"
      :transfer="false" :mask-closable="false" :title="supplierTitle" @on-visible-change="supplierModalChange">
      <Form :model="addSupplierForm" :disabled="supplierType === 'look'" ref="addSupplierForm" :rules="ruleValidate"
        :label-width="160" @submit.native.prevent>
        <!--账号信息-->
        <Card :bordered="false" dis-hover v-if="showInfoTalg">
          <template #title>
            <h2 class="title_box">{{ $t('key1002790') }}</h2>
          </template>
          <Row>
            <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
              <Form-item :label="$t('key1001174')" prop="mobile">
                <span v-if="viewStatus" class="labelText">{{ addSupplierForm.mobile }}</span>
                <Input v-else v-model.trim="addSupplierForm.mobile" :placeholder="$t('key1001001')" clearable
                  style="width: 350px;"></Input>
              </Form-item>
            </Col>
            <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
              <FormItem :label="$t('key1000068')" prop="email">
                <span v-if="viewStatus" class="labelText">{{ addSupplierForm.email }}</span>
                <Input v-else v-model.trim="addSupplierForm.email" :placeholder="$t('key1002765')" clearable
                  style="width: 350px;"></Input>
              </FormItem>
            </Col>
            <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol" v-if="!viewStatus">
              <Form-item prop="password" :class="supplierType === 'add' ? 'required_style_label' : ''">
                <template #label>{{ $t('key1002791') }}</template>
                <div class="flex align-items-center">
                  <Input v-model.trim="addSupplierForm.password" style="width: 263px;" :element-id="'addSupplierForm_password'" clearable></Input>
                  <Button type="primary" class="ml12"
                    @click="getStrongPassword('addSupplierForm', 'password')">{{ $t('key1002792') }}
                  </Button>
                </div>
              </Form-item>
            </Col>
          </Row>
        </Card>
        <!--企业信息-->
        <Card :bordered="false" dis-hover>
          <template #title>
            <h2 class="title_box">{{ $t('key1002793') }}</h2>
          </template>
          <Row>
            <languagesTabs ref="languagesTab" :tabsList="multilingualNamesList">
              <template v-for="item in multilingualNamesList">
                <template :slot="item.name">
                  <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
                    <Form-item :label="labelRander(item)" :prop="'name_' + item.code" :rules="getRules(item)">
                      <span v-if="viewStatus" class="labelText">{{ addSupplierForm['name_' + item.code] }}</span>
                      <Input v-else v-model.trim="addSupplierForm['name_' + item.code]" clearable :maxlength="255" class="width_350"></Input>
                    </Form-item>
                  </Col>
                </template>
              </template>
            </languagesTabs>
            <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
              <Form-item :label="$t('key1002766')" class="required_style_label">
                <Upload
                  class="upload_styles"
                  ref="upload"
                  type="drag"
                  name="files"
                  v-if="!viewStatus"
                  :headers="headObj"
                  :action="fileApi"
                  :data="uploadData"
                  :show-upload-list="false"
                  :on-success="(response, file, fileList)=> uploadSuccess(response, file, fileList, 'businessLicensePath')"
                  :format="['jpg', 'jpeg', 'png']"
                  :max-size="20480"
                  :on-format-error="handleFormatError"
                  :on-exceeded-size="handleMaxSize">
                  <div class="img_style" v-if="addSupplierForm.businessLicensePath">
                    <img :src="setImgPath(addSupplierForm.businessLicensePath)" alt=""/>
                  </div>
                  <div class="upload_icon_box" v-else>
                    <Icon type="ios-cloud-upload" size="45" style="color: #3399ff"></Icon>
                    <p>{{ $t('key1000465') }}</p>
                  </div>
                </Upload>
                <img v-else class="viewImgStyles" v-viewer="viewerOptions" :src="setImgPath(addSupplierForm.businessLicensePath)" alt=""/>
                <p class="font-size-12">{{ $t('key1002794') }}</p>
              </Form-item>
            </Col>
            <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
              <Form-item :label="$t('key1002767')" class="required_style_label">
                <div class="flex align-items-center">
                  <Upload
                    class="upload_styles"
                    ref="upload"
                    type="drag"
                    name="files"
                    v-if="!viewStatus"
                    :headers="headObj"
                    :action="fileApi"
                    :data="uploadData"
                    :show-upload-list="false"
                    :on-success="(response, file, fileList)=> uploadSuccess(response, file, fileList, 'identificationCardPath')"
                    :format="['jpg', 'jpeg', 'png']"
                    :max-size="20480"
                    :on-format-error="handleFormatError"
                    :on-exceeded-size="handleMaxSize">
                    <div class="img_style" v-if="addSupplierForm.identificationCardPath">
                      <img :src="setImgPath(addSupplierForm.identificationCardPath)" alt=""/>
                    </div>
                    <div class="upload_icon_box" v-else>
                      <Icon type="ios-cloud-upload" size="45" style="color: #3399ff"></Icon>
                      <p>{{ $t('key1002795') }}</p>
                    </div>
                  </Upload>
                  <img v-else class="viewImgStyles mr20" v-viewer="viewerOptions" :src="setImgPath(addSupplierForm.identificationCardPath)" alt=""/>
                  <Upload
                    class="upload_styles ml20"
                    ref="upload"
                    type="drag"
                    name="files"
                    v-if="!viewStatus"
                    :headers="headObj"
                    :action="fileApi"
                    :data="uploadData"
                    :show-upload-list="false"
                    :on-success="(response, file, fileList)=> uploadSuccess(response, file, fileList, 'identificationCardBackPath')"
                    :format="['jpg', 'jpeg', 'png']"
                    :max-size="20480"
                    :on-format-error="handleFormatError"
                    :on-exceeded-size="handleMaxSize">
                    <div class="img_style" v-if="addSupplierForm.identificationCardBackPath">
                      <img :src="setImgPath(addSupplierForm.identificationCardBackPath)" alt=""/>
                    </div>
                    <div class="upload_icon_box" v-else>
                      <Icon type="ios-cloud-upload" size="45" style="color: #3399ff"></Icon>
                      <p>{{ $t('key1002796') }}</p>
                    </div>
                  </Upload>
                  <img v-else class="viewImgStyles" v-viewer="viewerOptions" :src="setImgPath(addSupplierForm.identificationCardBackPath)" alt=""/>
                </div>
                <p class="font-size-12">{{ $t('key1002794') }}</p>
              </Form-item>
            </Col>
            <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
              <FormItem :label="$t('key1002768')" prop="scale">
                <span v-if="viewStatus" class="labelText">{{ addSupplierForm.scale }}</span>
                <Select v-else v-model="addSupplierForm.scale" transfer filterable :placeholder="$t('key1000101')"
                  style="width: 350px;">
                  <Option v-for="item in scaleList" :key="item.value" :value="item.value">{{ item.name }}</Option>
                </Select>
              </FormItem>
            </Col>
            <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
              <FormItem :label="$t('key1002769')" prop="contacts">
                <span v-if="viewStatus" class="labelText">{{ addSupplierForm.contacts }}</span>
                <Input v-else v-model.trim="addSupplierForm.contacts" :placeholder="$t('key1002770')" clearable
                  style="width: 350px;"></Input>
              </FormItem>
            </Col>
            <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
              <FormItem :label="$t('key1002771')" prop="contactsPhone">
                <span v-if="viewStatus" class="labelText">{{ addSupplierForm.contactsPhone }}</span>
                <Input v-else v-model.trim="addSupplierForm.contactsPhone" :placeholder="$t('key1002772')" clearable style="width: 350px;"></Input>
              </FormItem>
            </Col>
            <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
              <FormItem :label="$t('key1001175')" prop="phone">
                <span v-if="viewStatus" class="labelText">{{ addSupplierForm.phone }}</span>
                <Input v-else v-model.trim="addSupplierForm.phone" :placeholder="$t('key1002773')" clearable style="width: 350px;"></Input>
              </FormItem>
            </Col>
            <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol" v-if="!showInfoTalg">
              <FormItem :label="$t('key1000068')" prop="email">
                <span v-if="viewStatus" class="labelText">{{ addSupplierForm.email }}</span>
                <Input v-else v-model.trim="addSupplierForm.email" :placeholder="$t('key1002765')" clearable
                  style="width: 350px;"></Input>
              </FormItem>
            </Col>
          </Row>
        </Card>
        <!--店铺信息-->
        <Card :bordered="false" dis-hover v-if="showInfoTalg">
          <template #title>
            <h2 class="title_box">{{ $t('key1002797') }}</h2>
          </template>
          <Row>
            <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
              <FormItem :label="$t('key1002774')" prop="shopName">
                <span v-if="viewStatus" class="labelText">{{ addSupplierForm.shopName }}</span>
                <Input v-else v-model.trim="addSupplierForm.shopName" :placeholder="$t('key1002775')" clearable
                  style="width: 350px;"></Input>
              </FormItem>
            </Col>
            <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
              <FormItem :label="$t('key1002776')" prop="shopLogoPath" class="required_style_label">
                <Upload
                  class="upload_styles"
                  ref="upload"
                  type="drag"
                  name="files"
                  v-if="!viewStatus"
                  :headers="headObj"
                  :action="fileApi"
                  :data="uploadData"
                  :show-upload-list="false"
                  :on-success="(response, file, fileList)=> uploadSuccess(response, file, fileList, 'shopLogoPath')"
                  :format="['jpg', 'jpeg', 'png']"
                  :max-size="20480"
                  :on-format-error="handleFormatError"
                  :on-exceeded-size="handleMaxSize">
                  <div class="img_style" v-if="addSupplierForm.shopLogoPath">
                    <img :src="setImgPath(addSupplierForm.shopLogoPath)" alt=""/>
                  </div>
                  <div class="upload_icon_box" v-else>
                    <Icon type="ios-cloud-upload" size="45" style="color: #3399ff"></Icon>
                    <p>{{ $t('key1000465') }}</p>
                  </div>
                </Upload>
                <img v-else class="viewImgStyles" v-viewer="viewerOptions" :src="setImgPath(addSupplierForm.shopLogoPath)" alt=""/>
                <p class="font-size-12">{{ $t('key1002798') }}</p>
              </FormItem>
            </Col>
            <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
              <FormItem :label="$t('key1002777')" prop="managementModel">
                <span v-if="viewStatus" class="labelText">{{ addSupplierForm.managementModel }}</span>
                <Select v-else v-model="addSupplierForm.managementModel" transfer :placeholder="$t('key1000101')"
                  style="width: 350px;">
                  <Option v-for="item in managementModelList" :key="item.value" :value="item.value">{{ item.name }}</Option>
                </Select>
              </FormItem>
            </Col>
            <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
              <FormItem :label="$t('key1002778')" prop="plannedBusinessCategory">
                <span v-if="viewStatus" class="labelText">{{ addSupplierForm.plannedBusinessCategory }}</span>
                <Select v-else v-model="addSupplierForm.plannedBusinessCategory" transfer :placeholder="$t('key1000101')" multiple
                  style="width: 350px;">
                  <Option v-for="item in plannedBusinessCategoryList" :key="item.value" :value="item.value">{{ item.name }}</Option>
                </Select>
              </FormItem>
            </Col>
            <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
              <FormItem :label="$t('key1002779')" prop="shelvesProductsNumber" style="width: 350px;">
                <span v-if="viewStatus" class="labelText">{{ addSupplierForm.shelvesProductsNumber }}</span>
                <Select v-else v-model="addSupplierForm.shelvesProductsNumber" transfer :placeholder="$t('key1000101')">
                  <Option v-for="item in groundingList" :key="item.value" :value="item.value">{{ item.name }}</Option>
                </Select>
              </FormItem>
            </Col>
            <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol"
              v-show="addSupplierForm.productReleaseRate !==0">
              <FormItem :label="$t('key1002780')" prop="productReleaseNumber" class="reset_input_styles">
                <span v-if="viewStatus" class="labelText">{{ addSupplierForm.productReleaseNumber }}</span>
                <template v-if="!viewStatus">
                  <Input v-model.trim="addSupplierForm.productReleaseNumber" :placeholder="$t('key1002781')" clearable
                    style="width: 350px;">
                    <Select v-model="addSupplierForm.productReleaseRate" slot="prepend" style="width: 110px" :placeholder="$t('key1000101')">
                      <Option v-for="item in releaseTypeList" :key="item.value" :value="item.value">{{ item.name }}</Option>
                    </Select>
                    <span slot="append">{{ $t('key1002749') }}</span>
                  </Input>
                </template>
              </FormItem>
            </Col>
            <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol"
              v-show="addSupplierForm.productReleaseRate ===0">
              <FormItem :label="$t('key1002780')" prop="productReleaseRate" class="reset_input_styles">
                <span v-if="viewStatus" class="labelText">{{ addSupplierForm.productReleaseNumber }}</span>
                <Select v-else v-model="addSupplierForm.productReleaseRate" :placeholder="$t('key1000101')" style="width: 350px;">
                  <Option v-for="item in releaseTypeList" :key="item.value" :value="item.value">{{ item.name }}</Option>
                </Select>
              </FormItem>
            </Col>
            <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
              <FormItem :label="$t('key1002782')" prop="businessAddress">
                <span v-if="viewStatus" class="labelText">{{ addSupplierForm.businessAddress }}</span>
                <Cascader
                  v-else
                  style="width: 350px;"
                  v-model="addSupplierForm.businessAddress"
                  :data="businessAddressData"
                  filterable
                  change-on-select>
                </Cascader>
              </FormItem>
            </Col>
            <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
              <FormItem prop="address">
                <span v-if="viewStatus" class="labelText">{{ addSupplierForm.address }}</span>
                <Input v-else v-model.trim="addSupplierForm.address" :placeholder="$t('key1002783')" clearable
                  style="width: 350px;"></Input>
              </FormItem>
            </Col>
            <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
              <Form-item prop="settlementPeriodValue">
                <template #label>{{ $t('key1002799') }}</template>
                <div class="generateStyle">
                  <span v-if="viewStatus && !reviewAndEdit" class="labelText">{{ addSupplierForm.settlementPeriodType }}</span>
                  <Select v-if="!viewStatus || reviewAndEdit" v-model="addSupplierForm.settlementPeriodType" transfer disabled filterable
                    class="width_100" @on-change="changeCycle">
                    <Option v-for="(item, index) in settlementPeriodList" :value="item.value" :key="index">{{ item.name }}</Option>
                  </Select>
                  <span class="ml40">{{ $t('key1002231') }}</span>
                  <span v-if="viewStatus && !reviewAndEdit" class="font-size-12">{{ '【' + addSupplierForm.settlementPeriodValue + '】' }}</span>
                  <InputNumber v-if="!viewStatus || reviewAndEdit" :max="cycleMaxData" :min="1" v-model="addSupplierForm.settlementPeriodValue" class="ml6 mr6"></InputNumber>
                  <span>{{ $t('key1002800') }}</span>
                  <Tooltip v-if="!viewStatus" max-width="300" placement="top" class="ml5 cursor" transfer :content="$t('key1002784')">
                    <Icon size="18" type="md-help-circle"/>
                  </Tooltip>
                </div>
              </Form-item>
            </Col>
            <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
              <Form-item :label="$t('key1002785')" prop="ymsSupplierMerchantGradeId">
                <span v-if="viewStatus && !reviewAndEdit" class="labelText">{{ addSupplierForm.ymsSupplierMerchantGradeId }}</span>
                <Select v-if="!viewStatus || reviewAndEdit" v-model.trim="addSupplierForm.ymsSupplierMerchantGradeId" filterable transfer style="width:350px">
                  <Option v-for="(item, index) in supplierlevelList" :value="item.value" :key="index">{{ item.name }}</Option>
                </Select>
              </Form-item>
            </Col>
          </Row>
        </Card>
        <!--查看情况下才能看到有收款、审核结果信息-->
        <template v-if="supplierType === 'look'">
          <!--收款信息-->
          <Card :bordered="false" dis-hover>
            <template #title>
              <h2 class="title_box">{{ $t('key1002801') }}</h2>
            </template>
            <!--支付宝-->
            <Row v-if="paymentInfo.payType === 2">
              <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol" v-for="item in alipayInfoList">
                <Form-item :label="item.name">
                  <div class="flex align-items-center">
                    <span>{{ paymentInfo[item.paramsKey] }}</span>
                    <template v-if="['idCard'].includes(item.paramsKey) && getPermission('ymsSupplierMerchant_queryPayAccount')">
                      <Icon class="ml5 cursor" color="#2D8CF0" :size="19" v-if="!item.sensitiveTalg" type="md-eye-off" @click="viewPaymentInfo(item.paramsKey)"/>
                      <Icon class="ml5 cursor" color="#2D8CF0" :size="19" v-else type="md-eye" @click="encryptionbtn(item.paramsKey)"/>
                    </template>
                  </div>
                </Form-item>
              </Col>
            </Row>
            <!--银行卡-->
            <Row v-if="paymentInfo.payType === 1">
              <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol" v-for="item in paymentInfoList">
                <Form-item :label="item.name">
                  <div class="flex align-items-center">
                    <span>{{ paymentInfo[item.paramsKey] }}</span>
                    <template v-if="['idCard'].includes(item.paramsKey) && getPermission('ymsSupplierMerchant_queryPayAccount')">
                      <Icon class="ml5 cursor" color="#2D8CF0" :size="19" v-if="!item.sensitiveTalg" type="md-eye-off" @click="viewPaymentInfo(item.paramsKey)"/>
                      <Icon class="ml5 cursor" color="#2D8CF0" :size="19" v-else type="md-eye" @click="encryptionbtn(item.paramsKey)"/>
                    </template>
                  </div>
                </Form-item>
              </Col>
            </Row>
          </Card>
          <!--审核结果-->
          <Card :bordered="false" dis-hover>
            <template #title>
              <h2 class="title_box">{{ $t('key1002802') }}</h2>
            </template>
            <Row>
              <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
                <Form-item :label="$t('key1002786')">
                  <span>{{ processInfo.createdTime }}</span>
                </Form-item>
              </Col>
              <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol" v-if="[1,2].includes(toExamineStatus)">
                <Form-item :label="auditStatusText">
                  <span>{{ processInfo.supplierAuditStatusText }}</span>
                </Form-item>
              </Col>
              <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol"
                v-if="supplierDetails.supplierAuditStatus === 0">
                <Form-item :label="$t('key1002787')">
                  <span v-html="processInfo.auditRemarks"></span>
                </Form-item>
              </Col>
            </Row>
          </Card>
        </template>
        <!--仓库信息-->
        <Card :bordered="false" dis-hover v-if="['edit', 'look'].includes(supplierType) &&
        $route.path === '/supplierList' && warehouseInfoData.length >0">
          <template #title>
            <h2 class="title_box">{{ $t('key1002803') }}</h2>
          </template>
          <Collapse v-model="collapseModal" class="collapse_box">
            <Panel :name="index.toString()" v-for="(item,index) in warehouseInfoData" :key="index + '_collapse'">
              <div class="flex align-items-center">
                <div class="flex align-items-center mr30 font-weight-bold color-333 font-size-14 ellipsis_1"
                  style="max-width: 500px;" :title="item.warehouseName">
                  {{ $t('key1002327') + item.warehouseName }}
                </div>
                <div class="flex align-items-center" @click.stop="changeWarehouseType">
                  <span class="red-dot">{{ $t('key1002354') }}</span>
                  <CheckboxGroup v-model="item.warehouseTypes" class="flex align-items-center" @click.stop="changeWarehouseType">
                    <Checkbox @click.stop="changeWarehouseType" label="isCollectionWarehouse">{{ $t('key1002114') }}</Checkbox>
                    <Checkbox @click.stop="changeWarehouseType" label="isDeliveryWarehouse" class="ml40">{{ $t('key1002115') }}</Checkbox>
                  </CheckboxGroup>
                </div>
              </div>
              <template #content>
                <div class="flex align-items-center ml15 mb10">{{ $t('key1002351') + item.deliveryPlaceName }}</div>
                <div class="flex align-items-center ml15 mb10" v-if="item.warehouseShippingAddress">
                  {{ $t('key1002788') + item.warehouseShippingAddress }}
                </div>
                <div class="flex align-items-center ml15 mb10" v-if="item.warehouseReturnAddress">
                  {{ $t('key1002789') + item.warehouseReturnAddress }}
                </div>
                <!--供货仓配置-->
                <Card :bordered="false" dis-hover v-if="item.warehouseTypes.includes('isCollectionWarehouse')">
                  <template #title>
                    <h2 class="title_box">{{ $t('key1002355') }}</h2>
                  </template>
                  <Row type="flex" :gutter="gutterItem">
                    <Col :span="24" class="basic_item">
                      <div class="flex align-items-start">
                        <Tooltip transfer :content="$t('key1002346')" max-width="400" placement="top">
                          <Icon color="#2D8CF0" type="md-alert" class="cursor mr3" size="17"/>
                        </Tooltip>
                        <span class="width_175 display-inline-block">{{ $t('key1002804') }}</span>
                        <span style="flex: 1;">{{ item.consolidationWarehouseList.join('、') }}</span>
                      </div>
                    </Col>
                    <Col :span="24" class="basic_item">
                      <span class="basic_title">{{ $t('key1002357') }}</span>
                      <RadioGroup v-model="item.isProportion">
                        <Radio :disabled="true" :label="1">{{ $t('key1000392') }}</Radio>
                        <Radio :disabled="true" :label="0">{{ $t('key1000393') }}</Radio>
                      </RadioGroup>
                    </Col>
                  </Row>
                </Card>
                <!--直发仓配置-->
                <Card :bordered="false" dis-hover v-if="item.warehouseTypes.includes('isDeliveryWarehouse')">
                  <template #title>
                    <h2 class="title_box">{{ $t('key1002358') }}</h2>
                  </template>
                  <div class="flex align-items-center mb20">
                    <Tooltip transfer :content="$t('key1002348')" max-width="400" placement="top">
                      <Icon color="#2D8CF0" type="md-alert" class="cursor mr3" size="17"/>
                    </Tooltip>
                    <span class="basic_title red-dot">{{ $t('key1002363') }}</span>
                  </div>
                  <Tabs v-model="item.logisticsType" :animated="false" @on-click="(name) => changeTab(name, item, index)">
                    <TabPane :label="$t('key1001587')" name="selfOwnedLogistics"></TabPane>
                    <TabPane :label="$t('key1002349')" name="thirdPartyLogistics"></TabPane>
                  </Tabs>
                  <!--自有物流-->
                  <template v-if="item.logisticsType === 'selfOwnedLogistics'">
                    <Tabs type="card" :animated="false" v-model="item.logisticsChannelsType">
                      <TabPane v-for="(talg,index) in item.selfOwnedLogisticsData" :label="talg.carrierName" :name="talg.type + '_' + index">
                        <Tag class="mb10 mr25" v-for="ele in talg.carrierShippingMethods">{{ ele.carrierShippingMethodName }}</Tag>
                      </TabPane>
                    </Tabs>
                  </template>
                  <!--第三方物流-->
                  <template v-if="item.logisticsType === 'thirdPartyLogistics'">
                    <Tabs type="card" :animated="false" v-model="item.logisticsChannelsType">
                      <TabPane v-for="(talg,index) in item.thirdPartyLogisticsData" :label="talg.carrierName" :name="talg.type + '_' + index">
                        <Tag class="mb10 mr25" v-for="ele in talg.carrierShippingMethods">{{ ele.carrierShippingMethodName }}</Tag>
                      </TabPane>
                    </Tabs>
                  </template>
                </Card>
              </template>
            </Panel>
          </Collapse>
        </Card>
      </Form>
      <template #footer>
        <template v-if="supplierType === 'audit'">
          <Button type="error" ghost @click="rejectBtn" v-if="supplierDetails.supplierAuditStatus !== 0">{{ $t('key1002713') }}</Button>
          <Button type="primary" @click="approvedBtn">{{ $t('key1000986') }}</Button>
        </template>
        <template v-if="['add', 'edit'].includes(supplierType)">
          <Button @click="addSupplierModal = false">{{ $t('key1000112') }}</Button>
          <Button type="primary" @click="submitBtn">{{ $t('key1000555') }}</Button>
        </template>
      </template>
    </Modal>
    <!--驳回弹窗-->
    <rejectApplicationModal
      ref="rejectApplication"
      :toExamineStatus="toExamineStatus"
      :ymsMerchantId="ymsMerchantId"
      @resetDetails="resetDetails"
      @rejectApplicationUpdateData="rejectApplicationUpdateData">
    </rejectApplicationModal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import api from '@/api/';
import Mixin from '@/components/mixin/common_mixin';
import rejectApplicationModal from "@/views/yms/components/supplierManagement/rejectApplicationModal.vue";
import languagesTabs from "@/components/common/languagesTabs.vue";
import {
  getAllCountrysData, getAllYmsWarehouseData, getDataSetBatchList,
  getDeliveryAreasAllData, getEnumList, isJSON, getEnumName
} from "@/utils/common";

export default {
  name: "addSupplierModal",
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      addSupplierModal: false,
      supplierTitle: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002727'),
      supplierType: 'add', // 操作类型
      fileApi: api.erpCommon_uploadFiles + '?basePath=yms-core-service&action="uploadimage"',
      uploadData: {},
      addSupplierForm: {
        name: '', // 公司名称
        businessLicensePath: '', // 营业执照
        identificationCardBackPath: null, // 法人身份证国徽面
        identificationCardPath: null, // 法人身份证人像面
        scale: null, // 经营规模:1.10人以下、2.10~30人、3.30~50人、4.50~100人、5.100人以上
        contacts: '', // 联系人
        mobile: '', // 手机号码
        contactsPhone: '', // 联系人手机号码
        phone: '', // 固定电话
        email: '', // 邮箱
        password: '', // 密码

        shopName: '', // 店铺名称
        shopLogoPath: null, // 店铺logo
        managementModel: null, // 经营模式 1.自有工厂、2.渠道代理、3.经销批发
        plannedBusinessCategory: [], //  类目:1.经营类目  类目值:1.女装、2.男装、3.男童、4.女童、5.婴童
        shelvesProductsNumber: null, // 预计上架商品数  1.10以下 2.10~30 3.30~50 4.50~100 5.100以上
        productReleaseRate: null, // 商品发布频率:0.待定、1.每天发布、2.每周发布、3.每月发布
        productReleaseNumber: null, // 商品发布数
        businessAddress: [], // 营业地址
        address: '', // 详细地址

        settlementPeriodType: 1, // 账期结算类型 1 月 2 半月 3 周
        settlementPeriodValue: 30, // 账期结算数
        ymsSupplierMerchantGradeId: null, // 供应商商户等级
      },
      ruleValidate: {
        phone: [{required: false, validator: v.validateFixedTelephone(), trigger: 'blur'}],
        scale: [{required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002728'), trigger: 'change', type: 'number'}],
        contacts: [{required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002729'), trigger: 'blur'}],
        contactsPhone: [{required: true, validator: v.validateMobile(), trigger: 'blur'}],
        mobile: [{required: true, validator: v.validateMobile(), trigger: 'blur'}],
        email: [{validator: v.validateMailboxFormat(false), trigger: 'blur'}],
        password: [{required: false, validator: v.password(), trigger: 'blur'}],
        shopName: [{required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002730'), trigger: 'blur'}],
        managementModel: [{required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002731'), trigger: 'change', type: 'number'}],
        plannedBusinessCategory: [{required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002732'), trigger: 'change', type: 'array'}],
        shelvesProductsNumber: [{required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002733'), trigger: 'change', type: 'number'}],
        productReleaseNumber: [{required: true, validator: v.validatePositiveInteger(), trigger: 'blur'}],
        businessAddress: [{required: true, validator: v.validateCascaderValue(), trigger: 'change'}],
        address: [{required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001156'), trigger: 'blur'}],
        ymsSupplierMerchantGradeId: [{required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002734'), trigger: 'change'}],
        settlementPeriodValue: [{required: true, validator: v.settlementPeriod(), trigger: 'change'}]
      },
      cycleMaxData: 30,
      supplierlevelList: [],
      supplierDetails: {},
      ymsMerchantId: null,
      scaleList: [
        {value: 1, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002735')},
        {value: 2, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002736')},
        {value: 3, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002737')},
        {value: 4, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002738')},
        {value: 5, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002739')}
      ], // 经营规模
      groundingList: [
        {value: 1, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002740')},
        {value: 2, name: '10~30'},
        {value: 3, name: '30~50'},
        {value: 4, name: '50~100'},
        {value: 5, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002741')}
      ], // 预计上架商品数
      countrysList: [],
      paymentInfo: {}, // 收款信息
      ymsMerchantStoreAttributes: [],
      ymsMerchantStoreAddressId: null,
      ymsMerchantStoreId: null,
      countryId: null,
      stateData: [],
      processInfo: {}, // 审核信息
      paymentInfoList: [
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002702'), paramsKey: 'payTypeName'},
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002703'), paramsKey: 'name'},
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002704'), paramsKey: 'issuingBank'},
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002705'), paramsKey: 'payAccountNumber'},
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002706'), paramsKey: 'idCard', sensitiveTalg: false}
      ],
      alipayInfoList: [
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002702'), paramsKey: 'payTypeName'},
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002707'), paramsKey: 'payAccountNumber'},
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002703'), paramsKey: 'name'},
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002709'), paramsKey: 'idCard', sensitiveTalg: false}
      ],
      labelRander: (params) => {
        return aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002742') + params.title + aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002424');
      },
      toExamineStatus: null,
      auditType: null,
      detailsData: {},
      modalKey: Math.floor(Math.random() * 1000),
      businessAddressData: [],
      collapseModal: ['0'],
      warehouseInfoData: [],
      selfOwnedLogisticsData: [],
      thirdPartyLogisticsData: [],
      placeOfShipmentList: [],
      ymsWarehouseData: [],
      reviewAndEdit: false,  // 审核时，可以编辑指定字段的状态标识
      enumData: []
    };
  },
  computed: {
    // 查看、审核的状态下
    viewStatus() {
      return ['look', 'audit'].includes(this.supplierType);
    },
    auditStatusText() {
      return this.toExamineStatus === 1 ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002743') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002744');
    },
    showInfoTalg() {
      const result = !(this.toExamineStatus === 2 || (this.toExamineStatus === 3 && this.auditType === 2));
      this.$nextTick(() => {
        if (this.$refs['addSupplierForm'] && this.$refs['addSupplierForm'].fields) {
          // 强制刷新表单数据
          this.$refs['addSupplierForm'].resetFields();
        }
      });
      return result;
    },
    // 经营模式
    managementModelList() {
      const ENUM_KEY = 'YmsMerchantStoreManagementModelCoreEnum';
      return getEnumList(this.enumData, ENUM_KEY, 'number')
    },
    // 发布类型
    releaseTypeList() {
      const ENUM_KEY = 'YmsMerchantStoreProductReleaseRateCoreEnum';
      return getEnumList(this.enumData, ENUM_KEY, 'number')
    },
    // 计划经营类目
    plannedBusinessCategoryList() {
      const ENUM_KEY = 'YmsMerchantStoreAttributeAttributeValueCoreEnum';
      return getEnumList(this.enumData, ENUM_KEY, 'number')
    },
    // 账期结算
    settlementPeriodList() {
      const ENUM_KEY = 'YmsMerchantSettlementPeriodTypeCoreEnum';
      let list = getEnumList(this.enumData, ENUM_KEY, 'number');
      let obj = {
        1: 30,
        2: 15,
        3: 7,
      }
      return list.map(item => {
        item.maxDate = obj[item.value];
        return item;
      });
    },
  },
  methods: {
    // 初始化供应商
    async initSupplierData(type, data, toExamineStatus, value) {
      let v = this;
      let enumKeyList = [
        'YmsMerchantStoreManagementModelCoreEnum',
        'YmsMerchantStoreProductReleaseRateCoreEnum',
        'YmsMerchantStoreAttributeAttributeValueCoreEnum',
        'YmsMerchantSettlementPeriodTypeCoreEnum',
        'YmsSupplierMerchantDetailSupplierAuditStatusCoreEnum'
      ];
      v.enumData = await getDataSetBatchList(enumKeyList);
      v.modalKey += 1;
      v.ymsMerchantId = null;
      if (!value) {
        v.detailsData = {};
      }
      if (data) {
        v.detailsData = JSON.parse(JSON.stringify(data));
        v.ymsMerchantId = data.ymsMerchantId || null;
        v.auditType = data.auditType;
      }
      if (toExamineStatus) {
        v.toExamineStatus = Number(toExamineStatus); // 1 入驻审核、2 工商信息变更审核、3 审核驳回
      }
      let obj = {
        look: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002745'),
        edit: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002746'),
        add: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002727'),
        audit: v.toExamineStatus === 1 ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002747') : v.toExamineStatus === 2 ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002748') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002745'),
      };
      v.supplierTitle = obj[type];
      v.supplierType = type;
      v.$refs['languagesTab'].tabName = v.languagesVal;
      v.initMultilingualFields('addSupplierForm', v.addSupplierForm, ['name_']);
      if (type === 'audit') {
        v.reviewAndEdit = true;
      } else {
        v.reviewAndEdit = false;
      }
      (async () => {
        await v.getProvinceBasicData('CN').then((list) => {
          if (list.length > 0) {
            v.businessAddressData = list;
          }
        });
        await getAllCountrysData('cn', true).then((countrysList) => {
          v.countrysList = countrysList;
        });
        await getAllYmsWarehouseData().then((list) => {
          v.ymsWarehouseData = list;
        });
        await getDeliveryAreasAllData().then((list) => {
          v.placeOfShipmentList = list;
        });
        v.getSupplierlevelList();
        if (['edit', 'look', 'audit'].includes(type)) {
          v.getLogisticsDataEnabledAllData(type, data.ymsMerchantId);
        } else {
          v.addSupplierModal = true;
          v.$forceUpdate();
        }
      })();
    },
    // 获取供应商详情数据
    getSupplierDetails(type, ymsMerchantId) {
      let v = this;
      let url = '';
      if (v.toExamineStatus) {
        url = api.get_ymsSupplierMerchant_audit;
      } else {
        url = api.get_ymsSupplierMerchant;
      }
      v.axios.get(url + ymsMerchantId, {loading: true}).then(response => {
        if (response.data.code === 0) {
          let data = response.data.datas;
          if (data) {
            let obj = v.handleMultilingualFormFields(data, ['name']);
            if (Object.keys(obj).length > 0) {
              for (let key in obj) {
                v.addSupplierForm[key] = obj[key];
              }
            }
            let newData = data.ymsSupplierMerchantDetail || {};
            newData = Object.assign({}, data, newData);
            let ymsMerchantStores = newData.ymsMerchantStores || [];
            // 收款信息
            let paymentInfo = data.queryYmsAlipayAccountResultBo || {};
            if (Object.keys(paymentInfo).length > 0) {
              paymentInfo.payTypeName = paymentInfo.payType === 1 ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002690') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002692');
              v.paymentInfo = paymentInfo;
              v.originalPaymentInfo = JSON.parse(JSON.stringify(paymentInfo));
            }

            // 审核信息
            switch (v.toExamineStatus) {
              case 1:
                v.processInfo.createdTime = v.$uDate.dealTime(data.createdTime, 'fulltime');
                break;
              case 2:
                v.processInfo.createdTime = v.$uDate.dealTime(newData.updateSupplierAuditTime, 'fulltime');
                break;
              case 3:
                v.processInfo.createdTime = v.$uDate.dealTime(newData.supplierAuditedTime, 'fulltime');
                break;
              default:
                v.processInfo.createdTime = v.$uDate.dealTime(data.createdTime, 'fulltime');
            }
            if (v.toExamineStatus === 1) {
              v.processInfo.supplierAuditStatusText = getEnumName(v.enumData, 'YmsSupplierMerchantDetailSupplierAuditStatusCoreEnum', newData.supplierAuditStatus, 'number');
            } else {
              v.processInfo.supplierAuditStatusText = getEnumName(v.enumData, 'YmsSupplierMerchantDetailSupplierAuditStatusCoreEnum', newData.updateSupplierAuditStatus, 'number');
            }
            if (newData.auditRemarks) {
              v.processInfo.auditRemarks = newData.auditRemarks.replace(/\n/g, "<br>");
            }
            v.supplierDetails = newData;
            // 处理仓库信息数据
            let ymsWarehouses = data.ymsWarehouses || [];
            let ymsWarehousesList = [];
            if (ymsWarehouses.length > 0) {
              ymsWarehouses.map((item) => {
                let obj = {
                  ymsWarehouseId: item.ymsWarehouseId,
                  warehouseName: item.name,
                  isProportion: 0,
                  logisticsType: 'selfOwnedLogistics',
                  logisticsChannelsType: 'selfOwnedLogistics_0',
                  // 仓库类型
                  warehouseTypes: [
                    ...(item.isCollectionWarehouse === 1 ? ['isCollectionWarehouse'] : []),
                    ...(item.isDeliveryWarehouse === 1 ? ['isDeliveryWarehouse'] : [])
                  ],
                  // 发货地
                  deliveryPlaceName: '',
                  // 供货仓配置
                  consolidationWarehouseList: [],
                  // 直发仓配置
                  selfOwnedLogisticsData: [],
                  thirdPartyLogisticsData: []
                }
                // 发货地
                v.placeOfShipmentList.map((ele) => {
                  if (item.ymsDeliveryPlaceId === ele.ymsDeliveryPlaceId) {
                    obj.deliveryPlaceName = ele.deliveryPlaceName;
                  }
                });
                // 仓库地址
                let ymsWarehouseAddress = item.ymsWarehouseAddress || [];
                if (ymsWarehouseAddress.length > 0) {
                  const {sender, return: returnAddr} = ymsWarehouseAddress.reduce(
                    (acc, item) => {
                      if (item.addressType === 'sender') acc.sender = item;
                      if (item.addressType === 'return') acc.return = item;
                      return acc;
                    }, {});
                  const senderCountry = sender ? v.countrysList.find(c => c.twoCode === sender.countryCode) : null;
                  const returnCountry = returnAddr ? v.countrysList.find(c => c.twoCode === returnAddr.countryCode) : null;
                  const addr = (...v) => v.filter(Boolean).join(' ');
                  let warehouseShippingAddress = '';
                  let warehouseReturnAddress = '';
                  // ===== 仓库发货地址 =====
                  if (sender) {
                    warehouseShippingAddress = `${sender.name || ''}  ${addr(
                      senderCountry?.cnName,
                      sender.state,
                      sender.city,
                      sender.district,
                      sender.street,
                      sender.street2,
                      sender.street3,
                      sender.phone
                    )}`;
                  }
                  // ===== 仓库退货地址 =====
                  if (returnAddr) {
                    warehouseReturnAddress = `${returnAddr.name || ''}  ${addr(
                      returnCountry?.cnName,
                      returnAddr.state,
                      returnAddr.city,
                      returnAddr.district,
                      returnAddr.street,
                      returnAddr.street2,
                      returnAddr.street3,
                      returnAddr.phone
                    )}`;
                  }
                  obj = Object.assign({}, obj, {warehouseShippingAddress, warehouseReturnAddress});
                }

                // 供货仓配置
                let ymsWarehouseCollectionSettings = item.ymsWarehouseCollectionSettings || [];
                if (ymsWarehouseCollectionSettings.length > 0) {
                  ymsWarehouseCollectionSettings.map((ele) => {
                    v.ymsWarehouseData.map((talg) => {
                      if (ele.targetYmsWarehouseId === talg.ymsWarehouseId) {
                        obj.consolidationWarehouseList.push(talg.name);
                      }
                    })
                  });
                }
                // 直发仓配置
                let ymsWarehouseDeliverySettingList = item.ymsWarehouseDeliverySettings || [];
                if (ymsWarehouseDeliverySettingList.length > 0) {
                  const settingMap = ymsWarehouseDeliverySettingList.reduce((map, setting) => {
                    const key = `${setting.carrierType}_${setting.carrierId}_${setting.carrierShippingMethodId}`;
                    map[key] = true;
                    return map;
                  }, {});
                  const filterCarrierData = (carrierData, carrierType) => {
                    return carrierData.map(carrier => {
                      const methods = carrier.carrierShippingMethods || [];
                      const filteredMethods = methods.filter(method => settingMap[`${carrierType}_${carrier.carrierId}_${method.shippingMethodId}`]);
                      filteredMethods.forEach((ele) => {
                        ele.type = carrierType === 1 ? 'selfOwnedLogistics' : 'thirdPartyLogistics';
                      });
                      return {
                        ...carrier,
                        carrierShippingMethods: filteredMethods,
                      };
                    }).filter(carrier => carrier.carrierShippingMethods.length > 0);
                  };
                  // 过滤自有物流和第三方物流
                  obj.selfOwnedLogisticsData = filterCarrierData(v.selfOwnedLogisticsData, 1);
                  obj.thirdPartyLogisticsData = filterCarrierData(v.thirdPartyLogisticsData, 2);
                }
                ymsWarehousesList.push(obj);
              });
              v.warehouseInfoData = ymsWarehousesList;
            }

            // 处理查看、审核供应商信息的数据
            function handleInfoData(obj) {
              let keyList = [
                'businessLicensePath',
                'identificationCardBackPath',
                'identificationCardPath',
                'contacts',
                'mobile',
                'contactsPhone',
                'phone',
                'email',
                'password',
                'settlementPeriodValue'
              ];
              keyList.map((key) => {
                v.addSupplierForm[key] = obj[key];
              });
              let selectkeyList = ['scale', 'settlementPeriodType', 'ymsSupplierMerchantGradeId'];
              let selectKeyObj = {
                scale: v.scaleList,
                settlementPeriodType: v.settlementPeriodList,
                ymsSupplierMerchantGradeId: v.supplierlevelList,
              };

              selectkeyList.map((key) => {
                let list = selectKeyObj[key];
                if (list.length > 0) {
                  list.map((ele) => {
                    if (ele.value === obj[key]) {
                      v.addSupplierForm[key] = ele.name;
                    }
                  })
                }
              });
              // 店铺信息
              if (ymsMerchantStores.length > 0) {
                let storesObj = ymsMerchantStores[0];
                let storeskeyList = ['shopLogoPath', 'productReleaseNumber'];
                storeskeyList.map((key) => {
                  v.addSupplierForm[key] = storesObj[key];
                });
                let selectStoreskeyList = ['managementModel', 'shelvesProductsNumber', 'productReleaseRate'];
                let selectStoresKeyObj = {
                  managementModel: v.managementModelList,
                  shelvesProductsNumber: v.groundingList,
                  productReleaseRate: v.releaseTypeList,
                };

                selectStoreskeyList.map((key) => {
                  let list = selectStoresKeyObj[key];
                  if (list.length > 0) {
                    list.map((ele) => {
                      if (ele.value === storesObj[key]) {
                        v.addSupplierForm[key] = ele.name;
                      }
                    })
                  }
                });
                let productReleaseName = v.addSupplierForm.productReleaseRate + v.addSupplierForm.productReleaseNumber + aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002749');
                v.addSupplierForm.productReleaseNumber = v.addSupplierForm.productReleaseRate !== aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002750') ? productReleaseName : v.addSupplierForm.productReleaseRate;
                v.addSupplierForm.shopName = storesObj.name;
                v.ymsMerchantStoreAttributes = storesObj.ymsMerchantStoreAttributes || [];
                if (v.ymsMerchantStoreAttributes.length > 0) {
                  let categoryList = [];
                  v.ymsMerchantStoreAttributes.map((item) => {
                    v.plannedBusinessCategoryList.map((ele) => {
                      if (ele.value === item.attributeValue) {
                        categoryList.push(ele.name);
                      }
                    })
                  });
                  if (categoryList.length > 0) {
                    v.addSupplierForm.plannedBusinessCategory = categoryList.join('、');
                  } else {
                    v.addSupplierForm.plannedBusinessCategory = '';
                  }
                }
                // 处理地址信息
                let ymsMerchantStoreAddresses = storesObj.ymsMerchantStoreAddresses || [];
                v.addSupplierForm.businessAddress = '';
                if (ymsMerchantStoreAddresses.length > 0) {
                  let addressesInfo = ymsMerchantStoreAddresses[0];
                  v.addSupplierForm.businessAddress = v.handleAddressName(addressesInfo, v.businessAddressData);
                  v.addSupplierForm.address = obj.address ? obj.address : addressesInfo.street;
                  v.ymsMerchantStoreAddressId = addressesInfo.ymsMerchantStoreAddressId;
                }
              }
            }

            // 处理编辑供应商信息的数据
            function handleEditData(obj) {
              let keyList = [
                'businessLicensePath',
                'identificationCardBackPath',
                'identificationCardPath',
                'contacts',
                'mobile',
                'contactsPhone',
                'phone',
                'email',
                'password',
                'settlementPeriodValue',
                'scale', 'settlementPeriodType', 'ymsSupplierMerchantGradeId'
              ];
              keyList.map((key) => {
                v.addSupplierForm[key] = obj[key];
              });

              // 店铺信息
              if (ymsMerchantStores.length > 0) {
                let storesObj = ymsMerchantStores[0];
                let storeskeyList = ['shopLogoPath', 'productReleaseNumber', 'managementModel', 'shelvesProductsNumber', 'productReleaseRate'];
                storeskeyList.map((key) => {
                  v.addSupplierForm[key] = storesObj[key];
                });
                v.ymsMerchantStoreId = storesObj.ymsMerchantStoreId;

                v.addSupplierForm.shopName = storesObj.name;

                v.addSupplierForm.plannedBusinessCategory = [];
                v.ymsMerchantStoreAttributes = storesObj.ymsMerchantStoreAttributes || [];
                if (v.ymsMerchantStoreAttributes.length > 0) {
                  let newList = [];
                  v.ymsMerchantStoreAttributes.map((item) => {
                    newList.push(item.attributeValue)
                  });
                  v.addSupplierForm.plannedBusinessCategory = v.uniqueFunc(newList);
                }
                // 处理地址信息
                v.addSupplierForm.businessAddress = [];
                let ymsMerchantStoreAddresses = storesObj.ymsMerchantStoreAddresses || [];
                if (ymsMerchantStoreAddresses.length > 0) {
                  let addressesInfo = ymsMerchantStoreAddresses[0];
                  v.addSupplierForm.address = obj.address ? obj.address : addressesInfo.street;
                  v.ymsMerchantStoreAddressId = addressesInfo.ymsMerchantStoreAddressId;
                  v.addSupplierForm.businessAddress = [addressesInfo.state, addressesInfo.city, addressesInfo.district];
                }
              }
            }

            if (type === 'edit') {
              handleEditData(newData);
            } else {
              handleInfoData(newData);
              if (v.reviewAndEdit) {
                let keyList = ['settlementPeriodType', 'settlementPeriodValue', 'ymsSupplierMerchantGradeId'];
                keyList.map((key) => {
                  v.addSupplierForm[key] = newData[key];
                });
              }
            }

            let value = v.addSupplierForm.settlementPeriodType;
            switch (value) {
              case 1:
                v.cycleMaxData = 30;
                break;
              case 2:
                v.cycleMaxData = 15;
                break;
              case 3:
                v.cycleMaxData = 7;
                break;
              default:
                v.cycleMaxData = 0;
                break;
            }
            v.addSupplierModal = true;
            v.$forceUpdate();
          }
        }
      });
    },
    // 查看收款信息
    viewPaymentInfo(key) {
      let v = this;
      v.axios.get(api.get_ymsSupplierMerchant_queryPayAccount + v.ymsMerchantId).then(response => {
        if (response.data.code === 0) {
          let data = response.data.datas;
          if (data) {
            v.paymentInfo[key] = data[key];
            if (v.paymentInfo.payType === 2) {
              v.alipayInfoList.map((item) => {
                if (item.paramsKey === key) {
                  item.sensitiveTalg = true;
                }
              });
            } else {
              v.paymentInfoList.map((item) => {
                if (item.paramsKey === key) {
                  item.sensitiveTalg = true;
                }
              });
            }
            v.$forceUpdate();
          }
        }
      })
    },
    // 加密数据
    encryptionbtn(key) {
      this.paymentInfo[key] = JSON.parse(JSON.stringify(this.originalPaymentInfo[key]));
      if (this.paymentInfo.payType === 2) {
        this.alipayInfoList.map((item) => {
          if (item.paramsKey === key) {
            item.sensitiveTalg = false;
          }
        });
      } else {
        this.paymentInfoList.map((item) => {
          if (item.paramsKey === key) {
            item.sensitiveTalg = false;
          }
        });
      }
      this.$forceUpdate();
    },
    // 获取供应商等级所有数据
    getSupplierlevelList() {
      let v = this;
      v.supplierlevelList = [];
      v.axios.get(api.get_ymsSupplierMerchantGrade_list).then(response => {
        if (response.data.code === 0) {
          let data = response.data.datas || [];
          if (data.length > 0) {
            data.map((item) => {
              item.value = item.ymsSupplierMerchantGradeId
            });
            v.supplierlevelList = data;
          }
        }
      });
    },
    // （营业执照、法人身份证、店铺logo）--上传成功
    uploadSuccess(response, file, fileList, type) {
      let v = this;
      let uploadList = [
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002751'), key: 'businessLicensePath'},
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002752'), key: 'identificationCardBackPath'},
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002753'), key: 'identificationCardPath'},
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002754'), key: 'shopLogoPath'},
      ];
      uploadList.map((item) => {
        if (item.key === type) {
          if (response.code === 0) {
            v.addSupplierForm[item.key] = response.datas[0];
            v.$Message.success(`${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000682')}${item.name}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000683')}`);
          } else {
            v.$Message.error(`${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000682')}${item.name}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000684')}`);
          }
        }
      });
    },
    // 校验文件格式
    handleFormatError(file) {
      let v = this;
      v.$Message.error({
        content: `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002532')}${file.name}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002533')} ${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002726')}`,
        duration: 5
      });
    },
    // 限制上传的文件不能超过20M
    handleMaxSize(file) {
      let v = this;
      v.$Message.error({
        content: `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000030')}${file.name}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000031')} ${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000032')}`,
        duration: 5
      });
    },
    // 新增、编辑供应商的确定按钮
    submitBtn() {
      let v = this;
      let url = '';
      let method = '';
      let text = '';

      // 校验表单必填项
      function validateForm(obj) {
        let talg = true;
        // 校验上传的图片
        let uloadImgList = [
          {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002755'), key: 'businessLicensePath'},
          {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002756'), key: 'identificationCardBackPath'},
          {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002757'), key: 'identificationCardPath'},
          {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002758'), key: 'shopLogoPath'},
        ];
        let newList = [];
        if (v.showInfoTalg) {
          newList = uloadImgList;
          if (obj.productReleaseRate === null) {
            talg = false;
            v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002759'));
            return false;
          }
        } else {
          newList = uloadImgList.filter((item) => {
            return item.key !== 'shopLogoPath'
          })
        }
        for (let i = 0; i < newList.length; i++) {
          let item = newList[i];
          if (!obj[item.key]) {
            talg = false;
            v.$Message.warning(item.title);
            return false;
          }
        }
        return talg;
      }

      // 处理参数
      function handleParams(obj) {
        if (v.showInfoTalg) {
          let params = {
            ymsSupplierAscriptionWarehouses: [],
            updateYmsMerchantStoreBo: {
              managementModel: obj.managementModel,
              name: obj.shopName,
              productReleaseNumber: obj.productReleaseRate !== 0 ? obj.productReleaseNumber : null,
              productReleaseRate: obj.productReleaseRate,
              shelvesProductsNumber: obj.shelvesProductsNumber,
              shopLogoPath: obj.shopLogoPath,
              ymsMerchantStoreId: v.ymsMerchantStoreId || null,
              supplierMerchantId: v.ymsMerchantId || null,
              updateYmsMerchantStoreAddressBos: [
                {
                  city: obj.businessAddress[1], // 城市
                  countryCode: 'CN', // 国家或地区二字码
                  district: obj.businessAddress[2], // 区域
                  state: obj.businessAddress[0], // 省/州
                  street: obj.address,
                  ymsMerchantStoreAddressId: v.ymsMerchantStoreAddressId || null,
                }
              ],
              updateYmsMerchantStoreAttributeBos: []
            }
          };
          let enterpriseKeyList = [
            'businessLicensePath',
            'identificationCardBackPath',
            'identificationCardPath',
            'scale',
            'contacts',
            'mobile',
            'contactsPhone',
            'phone',
            'email',
            'password',
            'settlementPeriodType',
            'settlementPeriodValue',
            'ymsSupplierMerchantGradeId'
          ];
          enterpriseKeyList.map((key) => {
            params[key] = obj[key]
          });
          // 处理公司中英文名称
          params.name = v.handleMultilingualSingleParam(obj, 'name_');
          // 处理计划经营类目参数
          obj.plannedBusinessCategory.map((item) => {
            let ymsMerchantStoreAttributeId = null;
            if (v.ymsMerchantStoreAttributes.length > 0) {
              v.ymsMerchantStoreAttributes.map((ele) => {
                if (item === ele.attributeValue) {
                  ymsMerchantStoreAttributeId = ele.ymsMerchantStoreAttributeId;
                }
              });
            }
            params.updateYmsMerchantStoreBo.updateYmsMerchantStoreAttributeBos.push({
              attributeId: 1, // 类目:1.经营类目
              attributeValue: item, // 类目值:1.女装、2.男装、3.男童、4.女童、5.婴童
              ymsMerchantStoreAttributeId: ymsMerchantStoreAttributeId,
            })
          })
          return params;
        } else {
          let query = {
            name: v.handleMultilingualSingleParam(obj, 'name_')
          }
          let keyList = [
            'scale',
            'contacts',
            'contactsPhone',
            'email',
            'phone',
            'businessLicensePath',
            'identificationCardBackPath',
            'identificationCardPath'
          ];
          for (let key of keyList) {
            query[key] = v.addSupplierForm[key];
          }
          return query;
        }
      }

      function handleData() {
        if (validateForm(v.addSupplierForm)) {
          let query = handleParams(v.addSupplierForm)
          if (v.supplierType === 'add') {
            url = api.post_ymsSupplierMerchant_create;
            method = 'post';
            text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001488');
          } else if (v.supplierType === 'edit') {
            if (v.showInfoTalg) {
              url = api.put_ymsSupplierMerchant_update;
              method = 'put';
            } else {
              url = api.post_ymsSupplierMerchant_updateSupplierCompanyInfo;
              method = 'post';
            }
            text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002279');
            query.ymsMerchantId = v.ymsMerchantId;
            let updateSupplierWarehouseBos = [];
            v.warehouseInfoData.map((item) => {
              updateSupplierWarehouseBos.push({
                warehouseId: item.ymsWarehouseId,
                isCollectionWarehouse: item.warehouseTypes.includes('isCollectionWarehouse') ? 1 : 0,
                isDeliveryWarehouse: item.warehouseTypes.includes('isDeliveryWarehouse') ? 1 : 0,
              })
            });
            query.updateSupplierWarehouseBos = updateSupplierWarehouseBos;
          }
          v.axios[method](url, query, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
            if (response.data.code === 0) {
              v.$Message.success(text);
              v.addSupplierModal = false;
              v.$emit('updateData', true);
            }
          });
        }
      }

      if (v.showInfoTalg) {
        v.$refs['addSupplierForm'].validate((valid) => {
          if (valid) {
            handleData();
          }
        });
      } else {
        let validateField = [
          'phone',
          'scale',
          'contacts',
          'contactsPhone'
        ];
        let list = [];
        if (v.multilingualNamesList.length > 0) {
          v.multilingualNamesList.map((item) => {
            let key = 'name_' + item.code;
            list.push(key);
          });
        }
        validateField = [...validateField, ...list];
        Promise.all(validateField.map(field => {
          if (v.$refs['addSupplierForm'].fields.some(f => f.prop === field)) {
            const promise = new Promise(function (resolve, reject) {
              v.$refs['addSupplierForm'].validateField(field, (error) => {
                resolve(error)
              })
            })
            return promise
          } else {
            return Promise.resolve(null);
          }
        })).then((data) => {
          if (data.every(i => !i)) {
            handleData();
          }
        });
      }
    },
    // 校验密码
    password() {
      let v = this;
      return function (rule, value, callback) {
        if (!value && v.supplierType !== 'edit') {
          return callback(new Error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000143')));
        } else {
          callback();
        }
      };
    },
    // 校验账期结算
    settlementPeriod() {
      return function (rule, value, callback) {
        if (!value) {
          return callback(new Error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002760')));
        } else {
          callback();
        }
      };
    },
    // 账期结算
    changeCycle(value) {
      this.addSupplierForm.settlementPeriodValue = null;
      this.settlementPeriodList.map((item) => {
        if (item.value === value) {
          this.cycleMaxData = item.maxDate;
          this.addSupplierForm.settlementPeriodValue = item.maxDate;
        }
      });
    },
    // 监听弹窗
    supplierModalChange(value) {
      if (!value) {
        this.$nextTick(() => {
          this.$refs['addSupplierForm'].resetFields();
        });
        for (let key in this.addSupplierForm) {
          this.addSupplierForm[key] = '';
          this.addSupplierForm.settlementPeriodType = 1;
          this.addSupplierForm.settlementPeriodValue = 30;
          this.addSupplierForm.ymsSupplierMerchantGradeId = null;
          this.ymsMerchantStoreId = null;
          this.processInfo = {};
          this.paymentInfo = {};
          this.paymentInfoList = handleFun(this.paymentInfoList, 'idCard');
          this.alipayInfoList = handleFun(this.alipayInfoList, 'idCard');

          function handleFun(list, paramsKey) {
            list.map((item) => {
              if (item.paramsKey === paramsKey) {
                item.sensitiveTalg = false;
              }
            })
            return list;
          }
        }
        this.addSupplierForm.businessAddress = [];
        this.supplierDetails = {};
        this.warehouseInfoData = [];
        this.supplierlevelList = [];
        this.countrysList = [];
        this.paymentInfo = {};
        this.ymsMerchantStoreAttributes = [];
        this.stateData = [];
        this.ymsMerchantStoreAddressId = null;
        this.ymsMerchantStoreId = null;
        this.processInfo = {};
        this.businessAddressData = [];
        this.collapseModal = ['0'];
        this.selfOwnedLogisticsData = [];
        this.thirdPartyLogisticsData = [];
        this.placeOfShipmentList = [];
        this.ymsWarehouseData = [];
        this.enumData = [];
      }
    },
    // 驳回按钮
    rejectBtn() {
      this.addSupplierModal = false;
      this.$refs['rejectApplication'].rejectApplicationModal = true;
    },
    // 重新获取详情数据
    resetDetails(val) {
      if (!val) {
        this.initSupplierData('audit', this.detailsData, this.toExamineStatus, true);
      }
    },
    // 审核通过
    approvedBtn() {
      let v = this;
      let params = {
        auditRemarks: null,
        updateYmsSupplierAscriptionWarehouseBos: [],
        ymsMerchantId: v.ymsMerchantId,
        settlementPeriodType: v.addSupplierForm.settlementPeriodType,
        settlementPeriodValue: v.addSupplierForm.settlementPeriodValue,
        ymsSupplierMerchantGradeId: v.addSupplierForm.ymsSupplierMerchantGradeId,
      };
      let url = '';
      if (v.toExamineStatus === 1) {
        params.supplierAuditStatus = 2; // 供应商入驻审核状态 0审核不通过、1待审核、2审核通过
        url = api.post_ymsSupplierMerchant_updateSupplierAuditInfo;
      } else {
        params.updateSupplierAuditStatus = 2; // 供应商工商信息变更审核状态: 0审核不通过、1待审核、2审核通过
        url = api.post_ymsSupplierMerchant_updateSupplierCompanyAuditInfo;
      }
      v.axios.post(url, params, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
        if (response.data.code === 0) {
          v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002694'));
          v.addSupplierModal = false;
          v.$emit('updateData', true);
        }
      });
    },
    // 驳回成功之后
    rejectApplicationUpdateData() {
      this.$refs['rejectApplication'].rejectApplicationTalg = false;
      this.$refs['rejectApplication'].rejectApplicationModal = false;
      this.addSupplierModal = false;
      this.$emit('updateData', true);
    },
    // 校验商品发布的具体数量
    validatePositiveInteger() {
      let v = this;
      let reg = v.$regular.positiveInteger;
      return function (rule, value, callback) {
        if (v.addSupplierForm.productReleaseRate !== 0) {
          if (!value) {
            callback(new Error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002761')));
          } else {
            const number = Number(value);
            if (!reg.test(number)) {
              callback(new Error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002762')));
            } else {
              callback();
            }
          }
        } else {
          callback();
        }
      }
    },
    // 校验营业地址
    validateCascaderValue() {
      return function (rule, value, callback) {
        if (!value || value.length <= 0) {
          callback(new Error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002763')));
        } else {
          if (value.length < 3) {
            callback(new Error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002764')));
          } else {
            callback();
          }
        }
      }
    },
    // 设置表单必填项校验规则
    getRules(item) {
      let v = this;
      let list = [];
      if (item.required) {
        list = [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002742') + item.title + aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002427'), trigger: 'blur'}
        ];
      }
      return list;
    },
    // 获取自有、第三方物流的数据
    async getLogisticsDataEnabledAllData(typeValue, ymsMerchantId) {
      if (this.supplierType !== 'audit') {
        const fetchLogisticsData = async (url, query) => {
          try {
            const response = await this.axios.post(url, query);
            if (response.data.code === 0) {
              return response.data.datas || [];
            }
            return [];
          } catch (error) {
            return [];
          }
        };
        const [selfOwnedLogisticsData, thirdPartyLogisticsData] = await Promise.all([
          fetchLogisticsData(api.post_ymsSupplierCarrier_api_queryForOwnCarriersList,
            {
              isFilter: true,
              status: 1,
              merchantId: ymsMerchantId
            }),
          fetchLogisticsData(api.post_ymsCarrier_query, {
            carrierIds: [],
            carrierName: '',
            status: 1
          })
        ]);
        const handleData = (data, type) => data.map(item => ({type, ...item}));
        const hanleName = (data) => {
          data.map((item) => {
            let carrierShippingMethods = item.carrierShippingMethods || [];
            carrierShippingMethods.map((ele) => {
              let name = ele.carrierShippingMethodName;
              if (isJSON(name)) {
                let obj = JSON.parse(name);
                ele.carrierShippingMethodName = obj[this.languagesVal];
              }
            })
          });
          return data;
        }
        this.selfOwnedLogisticsData = handleData(hanleName(selfOwnedLogisticsData), 'selfOwnedLogistics');
        this.thirdPartyLogisticsData = handleData(hanleName(thirdPartyLogisticsData), 'thirdPartyLogistics');
      }
      this.getSupplierDetails(typeValue, ymsMerchantId);
      this.$forceUpdate();
    },
    // 切换物流方式
    changeTab(name, item, index) {
      item.logisticsType = name;
      let data = name === 'selfOwnedLogistics' ? item.selfOwnedLogisticsData : item.thirdPartyLogisticsData;
      if (data.length > 0) {
        item.logisticsChannelsType = data[0].type + '_0';
      }
      // 强制更新以确保 CheckboxGroup 正确渲染
      this.$nextTick(() => {
        this.$forceUpdate();
      });
    },
    changeWarehouseType() {
    }
  },
  watch: {},
  components: {
    languagesTabs,
    rejectApplicationModal
  }
}
</script>

<style lang="less" scoped>
/deep/ .addSupplierStyle {

  .title_box {
    font-size: 15px;
    font-weight: bold;
    color: #000;
  }

  .ivu-modal-body {
    max-height: 650px;
    overflow-y: auto;
  }

  .ivu-input {
    height: 35px;
    line-height: 35px;
  }

  .upload_styles {
    .ivu-upload.ivu-upload-drag {
      width: 120px;
      height: 120px;
    }

    .upload_icon_box {
      width: 120px;
      height: 120px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-content: center;
    }

    .img_style {
      width: 120px;
      height: 120px;

      img {
        width: 100%;
        height: 100%;
        display: inline-block;
        object-fit: cover;
        vertical-align: middle;
      }
    }
  }

  .viewImgStyles {
    width: 120px;
    height: 120px;
    display: inline-block;
    object-fit: cover;
    vertical-align: middle;
    border-radius: 10px;
    overflow: hidden;
    border: 1px solid #D7D7D7;
    box-sizing: border-box;
    cursor: pointer;
  }

  .ivu-modal-body .ivu-modal-footer {
    padding: 0;
  }

  .ivu-modal-body .ivu-modal-footer .ivu-btn {
    margin: 0;
  }

  .ivu-modal-body .ivu-modal-footer .ivu-btn + .ivu-btn {
  }

  .labelText {
    font-size: 12px;
    position: relative;
    top: 1px;
  }

  .generateStyle {
    display: flex;
    align-items: center;

    .ivu-input {
      width: 100% !important;
    }
  }

  .selfadaptionStyle {
    label.ivu-form-item-label {
      width: 170px !important;
    }

    .ivu-form-item-content .ivu-radio-default {
      position: relative;
      top: -2px;
    }

    .labelText {
      position: relative;
      top: -2px;
    }
  }

  .tooltip_styles {
    position: relative;

    /deep/ .ivu-tooltip {
      position: absolute;
      top: 5px;
      cursor: pointer;
      left: 32px;
    }
  }

  .warehouse_box {
    display: flex;
    flex-direction: column;
    justify-content: center;

    .warehouse_box_item {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .first_choice {
        display: none;
      }

      &:hover {
        .first_choice {
          display: inline-block;
        }
      }
    }
  }

  .reset_input_styles {
    .ivu-input-group-prepend {
      padding: 0 8px 0 8px !important;
      background-color: transparent;
      text-align: left;
    }

    .ivu-input-group-append {
      padding: 0 10px 0 10px !important;
      background-color: transparent;
    }
  }

  .collapse_box .ivu-collapse-header {
    display: flex;
    align-items: center;
  }
}
</style>